import { useEffect } from 'react';
import { HeadWrapper, Wrapper, Head } from './organizations-management-page.styles';
import { Typography } from '@shared/ui/typography/typography';
import { Button } from '@vtbhome/juicyfront';
import { ArrowsChevronLeft } from '@vtbhome/juicyfront/indexIcon';
import { useHistory } from 'react-router-dom';
import { FilterOrganizations } from '@features/organization/filter-organizations/ui/filter-organizations';
import { useOrganizationsListSharedQuery } from '@entities/organization/libs/hooks/use-organizations-list-shared-query/use-organizations-list-shared-query';
import { ListOrganizationsManagement } from '@widgets/list-organizations-management/ui/list-organizations-management';
import { DEFAULT_ORGANIZATIONS_LIST_PARAMETERS } from '@entities/organization/config/store-constants';
import { OrganizationsListDataRequest } from '@entities/organization/api/organization-types';
import { useSearchParams } from '@shared/lib/hooks/use-search-params/use-search-params';

export const OrganizationsManagementPage = () => {
    const [organizationsListParameters, setOrganizationsListParameters] = useSearchParams<OrganizationsListDataRequest>(
        DEFAULT_ORGANIZATIONS_LIST_PARAMETERS
    );
    const [getOrganizationsList, getOrganizationsListResult] =
        useOrganizationsListSharedQuery(organizationsListParameters);
    const organizationsListLength = getOrganizationsListResult.isSuccess
        ? getOrganizationsListResult.data?.total || 0
        : undefined;
    const history = useHistory();

    useEffect(() => {
        getOrganizationsList(organizationsListParameters);
    }, [organizationsListParameters]);

    return (
        <Wrapper>
            <HeadWrapper>
                <Head>
                    {Boolean(history.length) && (
                        <Button
                            round
                            size='xl'
                            buttonType='secondary'
                            startAdornment={<ArrowsChevronLeft />}
                            onClick={() => history.goBack()}
                        />
                    )}
                    <Typography size='h6'>
                        Организации{' '}
                        {(Boolean(organizationsListLength) || organizationsListLength === 0) &&
                            `(${organizationsListLength})`}
                    </Typography>
                    <FilterOrganizations
                        organizationsListParameters={organizationsListParameters}
                        setOrganizationsListParameters={setOrganizationsListParameters}
                    />
                </Head>
            </HeadWrapper>
            <ListOrganizationsManagement
                organizationsListParameters={organizationsListParameters}
                setOrganizationsListParameters={setOrganizationsListParameters}
            />
        </Wrapper>
    );
};
